import axios from "axios";


const { REACT_APP_API_END_POINT } = process.env;

const axiosInstance = axios.create({
  baseURL: REACT_APP_API_END_POINT,
});

axiosInstance.interceptors.request.use(function (config) {
  if (localStorage.getItem('keycloakToken'))
  config.headers.Authorization =  `Bearer ${localStorage.getItem('keycloakToken')}`;;
  return config;
}, error =>{
  Promise.reject(error)
})

axiosInstance.interceptors.response.use(response=>{
  return response;
}, function(error){
  return Promise.reject(error)
});

export default axiosInstance;